/**
 * Дефолтные права доступа по ролям.
 * Используются как fallback если владелец ещё не настроил права.
 * Гарантируют обратную совместимость — сотрудники не потеряют доступ.
 */
export const PERMISSION_DEFAULTS = {
  employee: {
    // Видимость разделов
    canAccessDashboard: false,
    canAccessOperations: true,
    canAccessPayments: true,
    canAccessSchedule: true,
    canAccessChats: true,
    canAccessTasks: true,
    canAccessVacancies: false,
    canAccessCameras: false,
    canAccessAI: true,
    canAccessAnalytics: false,
    canAccessSettings: true,
    // Гранулярные права
    canSeeIncome: false,
    canEditSchedule: false,
    canManagePayments: false,
    canManageOperations: false,
    canManageDeductions: false,
    canManageExpenses: false,
    canAddOperationsForOthers: false,
    canViewApplications: false,
    canManageVacancies: false,
    canManageTeam: false,
    canManageSalaryConfig: false,
    canManageGeneralSettings: false,
  },
  helper: {
    canAccessDashboard: false,
    canAccessOperations: true,
    canAccessPayments: true,
    canAccessSchedule: true,
    canAccessChats: true,
    canAccessTasks: true,
    canAccessVacancies: false,
    canAccessCameras: false,
    canAccessAI: false,
    canAccessAnalytics: false,
    canAccessSettings: true,
    canSeeIncome: false,
    canEditSchedule: false,
    canManagePayments: false,
    canManageOperations: false,
    canManageDeductions: false,
    canManageExpenses: false,
    canAddOperationsForOthers: false,
    canViewApplications: false,
    canManageVacancies: false,
    canManageTeam: false,
    canManageSalaryConfig: false,
    canManageGeneralSettings: false,
  },
  admin: {
    canAccessDashboard: true,
    canAccessOperations: true,
    canAccessPayments: true,
    canAccessSchedule: true,
    canAccessChats: true,
    canAccessTasks: true,
    canAccessVacancies: true,
    canAccessCameras: false,
    canAccessAI: true,
    canAccessAnalytics: false,
    canAccessSettings: true,
    canSeeIncome: false,
    canEditSchedule: true,
    canManagePayments: true,
    canManageOperations: true,
    canManageDeductions: true,
    canManageExpenses: true,
    canAddOperationsForOthers: true,
    canViewApplications: true,
    canManageVacancies: true,
    canManageTeam: true,
    canManageSalaryConfig: true,
    canManageGeneralSettings: false,
  }
}

/**
 * Получить значение конкретного права с учётом дефолтов.
 * Если право явно задано в БД — берём его, иначе — дефолт.
 */
export function getPermission(perms, key, role) {
  const normalizedRole = role === 'owner' ? 'admin' : (role || 'employee')
  if (perms && key in perms) return perms[key] === true
  return PERMISSION_DEFAULTS[normalizedRole]?.[key] ?? true
}

/**
 * Маппинг id раздела → ключ права доступа к разделу
 */
export const SECTION_ACCESS_MAP = {
  dashboard: 'canAccessDashboard',
  operations: 'canAccessOperations',
  payments: 'canAccessPayments',
  schedule: 'canAccessSchedule',
  chat: 'canAccessChats',
  tasks: 'canAccessTasks',
  vacancies: 'canAccessVacancies',
  cameras: 'canAccessCameras',
  ai_assistant: 'canAccessAI',
  analytics: 'canAccessAnalytics',
  settings: 'canAccessSettings',
}
